import { STORAGE_KEYS } from '../utils/constants';

function isBadToken(token) {
  return (
    !token ||
    token === 'undefined' ||
    token === 'null' ||
    token === 'NaN'
  );
}

export function getStoredToken() {
  const token = localStorage.getItem(STORAGE_KEYS.TOKEN);
  if (isBadToken(token)) {
    localStorage.removeItem(STORAGE_KEYS.TOKEN);
    return null;
  }
  return token;
}

export function getStoredUser() {
  const raw = localStorage.getItem(STORAGE_KEYS.USER);
  if (!raw || raw === 'undefined' || raw === 'null') {
    localStorage.removeItem(STORAGE_KEYS.USER);
    return null;
  }
  try {
    const user = JSON.parse(raw);
    if (!user || typeof user !== 'object' || !user.id || !user.role) {
      localStorage.removeItem(STORAGE_KEYS.USER);
      return null;
    }
    return user;
  } catch {
    localStorage.removeItem(STORAGE_KEYS.USER);
    return null;
  }
}

export function saveAuthSession(token, user) {
  if (isBadToken(token) || !user?.id) {
    clearAuthSession();
    throw new Error('Invalid login session from server');
  }
  localStorage.setItem(STORAGE_KEYS.TOKEN, token);
  localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(user));
}

export function clearAuthSession() {
  localStorage.removeItem(STORAGE_KEYS.TOKEN);
  localStorage.removeItem(STORAGE_KEYS.USER);
}
